export class Response {};
